import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { ModerationPage } from '@/pages/moderation/ModerationPage'

export const Route = createFileRoute('/moderation')({
  component: () => (
    <RequirePermission section="moderation" action="view">
      <ModerationPage />
    </RequirePermission>
  ),
})
